import { Outlet } from "react-router-dom";

import WhatsAppButton from "js/components/WhatsAppButton";
import { useSessionData } from "hooks/useSessionData";

/**
 * Las páginas con sesión que ocupan toda la ventana, sin el menú ni el encabezado del tablero
 * (el editor de contratos). La salida la pone cada página.
 *
 * Carga la sesión igual que el encabezado del tablero (`useSessionData`): aquí no hay encabezado,
 * y sin eso una página abierta directo se quedaría esperando al usuario para siempre.
 */
const FullScreenLayout = () => {
  useSessionData();

  return (
    <div style={{ height: "100vh", overflow: "hidden", background: "#f2f5f9" }}>
      <WhatsAppButton />
      <Outlet />
    </div>
  );
};

export default FullScreenLayout;
